import { memo } from 'react';
import Popover from 'react-bootstrap/Popover';
import { BzButton } from "../../components";
import { Col, Row, OverlayTrigger } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toggleWalkThroughPopover } from "../../redux/actions/walkthroughPopovers"

const Walkthrough = (props) => {

    const { children, orderNo, placement } = props
    const walkthroughPopovers = useSelector(state => state.walkthroughPopovers)
    const dispatch = useDispatch()

    const handleNext = () => {
        if (Object.keys(walkthroughPopovers).length === orderNo) {
            dispatch(toggleWalkThroughPopover())
        } else {
            dispatch(toggleWalkThroughPopover(orderNo, orderNo + 1))
        }
    }

    const handlePrevious = () => {
        if (orderNo === 1) {
            dispatch(toggleWalkThroughPopover())
        } else {
            dispatch(toggleWalkThroughPopover(orderNo, orderNo - 1))
        }
    }


    const handleClose = () => {
        dispatch(toggleWalkThroughPopover())
    }



    const BzPopover = (
        <Popover className='scripdetails-popover'>
            <Popover.Header>
                <div className='p-2'>
                    <Row className='g-0'>
                        <Col className='flex-column justify-content-start align-items-start'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-medium font-size4 color-text'>Open Orders</div>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-self-center'>
                                    <div onClick={handleClose} className='icon-16 icon-close icon-dark'>&nbsp;</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Popover.Header>
            <Popover.Body className='d-flex flex-column'>
                <div className='bdr-top bdr-btm'>
                    <Row className='g-0 py-2 popover-menu'>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-dark icon-overview'></div>
                            <div className='font-regular font-size3 color-text ms-2'>
                                Lorem ipsum dolor sit amet. Non nobis
                                maiores vel dolorem optio non eaque dolores
                                sit aliquid mollitia sit rerum odio qui dolores
                                necessitatibus sit saepe blanditiis
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2 popover-menu'>
                        <Col className='d-flex justify-content-end mt-3'>
                            <div className='d-flex justify-content-end mt-3' onClick={handlePrevious}>
                                <BzButton className='btn btn-md btn-primary mx-1'>Back</BzButton>
                            </div>

                            <div className='d-flex justify-content-end mt-3'>
                                <BzButton className='btn btn-md btn-primary mx-1' onClick={handleNext}>Next</BzButton>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Popover.Body>
        </Popover>
    )



    return (
        Object.keys(walkthroughPopovers).length ? <OverlayTrigger trigger='click' show={walkthroughPopovers[orderNo]} placement={placement ? placement : 'auto'} overlay={BzPopover}>
            <span>
                {children}
            </span>
        </OverlayTrigger> : <>{children}</>
    );
};

export default memo(Walkthrough);
